module.exports = __webpack_public_path__ + "img/online.0fa3bf21.png";